module.exports = __webpack_public_path__ + "static/img/03-crunch.3c74bb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/03-crunch.jpg
// module id = 0B5P
// module chunks = 12